var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden","id":"gameID"},domProps:{"value":'MegaMillions'}}),_c('DrawDetail',{staticClass:"hide-tabs"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }